<script lang="ts">
  import { fly } from 'svelte/transition';
  import { cart, cartNotification } from '../../services/cart-service';
</script>

{#if $cartNotification.show}
  <div
    id="successAlert"
    class="success-alert"
    in:fly={{ y: 40, duration: 300 }}
    out:fly={{ y: 40, duration: 300 }}
  >
    <div class="container-fluid">
      <div class="row">
        <div class="col d-flex justify-content-center align-items-center">
          <i class="bi bi-check-circle-fill text-success me-2"></i>
          <span>
            <b
              >{$cartNotification.count > 1 ? `${$cartNotification.count} items` : 'Item'} added to cart!</b
            >
            Cart total: {$cartNotification.total}
            {$cartNotification.total === 1 ? 'item' : 'items'}
          </span>
          <a type="button" class="btn btn-sm ae-secondary ms-3" href="/access/search/cart">
            View Cart
          </a>
          <button
            type="button"
            class="btn-close ms-3"
            aria-label="Close"
            on:click={() => cart.dismissNotification()}
          ></button>
        </div>
      </div>
    </div>
  </div>
{/if}

<style>
  .success-alert {
    width: 100%;
    position: fixed;
    z-index: 5;
    bottom: 0;
    right: 0;
    background-color: #e8f5e9;
    padding: 10px 0;
    border-top: 1px solid #4caf50;
    border-bottom: 1px solid #4caf50;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
  }
</style>
